import {Alert} from '@wandb/weave/components/Alert';
import React from 'react';

import {TabMetadata} from './TabMetadata';
import {TabRuns} from './TabRuns';
import {TabVersionMetadata} from './TabVersionMetadata';
import {JobDetails} from './utilTypes';

type JobDetailTabContentsProps = {
  entityName: string;
  projectName: string;
  job: JobDetails;
  jobTab: string;
  jobVersion?: string;
  isDescriptionHighlighted: boolean;
};

export const JobDetailTabContents = ({
  entityName,
  projectName,
  job,
  jobTab,
  jobVersion,
  isDescriptionHighlighted,
}: JobDetailTabContentsProps) => {
  return (
    <>
      {jobTab === 'runs' && (
        <TabRuns entityName={entityName} projectName={projectName} job={job} />
      )}
      {jobTab === 'job_details' && (
        <TabMetadata
          entityName={entityName}
          projectName={projectName}
          job={job}
          isDescriptionHighlighted={isDescriptionHighlighted}
        />
      )}
      {jobTab === 'version_details' &&
        (job.versions.length && jobVersion ? (
          <TabVersionMetadata
            entityName={entityName}
            projectName={projectName}
            job={job}
            jobVersion={jobVersion}
          />
        ) : (
          <Alert severity="info">There are no versions of this job.</Alert>
        ))}
    </>
  );
};
